import { render, staticRenderFns } from "./BankAccountFormFieldsNg.vue?vue&type=template&id=1482e635"
import script from "./BankAccountFormFieldsNg.vue?vue&type=script&lang=js"
export * from "./BankAccountFormFieldsNg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.16_babel-core@7.0.0-bridge.0_@babel+core@7.27._f767d633ff263e3cf51932694db5e4d0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/front/game-platform-web/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1482e635')) {
      api.createRecord('1482e635', component.options)
    } else {
      api.reload('1482e635', component.options)
    }
    module.hot.accept("./BankAccountFormFieldsNg.vue?vue&type=template&id=1482e635", function () {
      api.rerender('1482e635', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/admin/member/components/bankAccountForm/BankAccountFormFieldsNg.vue"
export default component.exports